const MESES = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

/** Convierte mapas mes→importe a serie { mes: { real, estimate, diff }, total }. */
export const toRealPptoSerie = (datosMes, estimateMes) => {
  if (!datosMes && !estimateMes) {
    return { total: { real: 0, estimate: 0, diff: 0 } };
  }

  if (datosMes?.["1"]?.real !== undefined || datosMes?.total?.real !== undefined) {
    return datosMes;
  }

  const out = {};
  let totalReal = 0;
  let totalEstimate = 0;

  MESES.forEach((mes) => {
    const real = Number(datosMes?.[mes] ?? 0);
    const estimate = Number(estimateMes?.[mes] ?? 0);
    out[mes] = { real, estimate, diff: real - estimate };
    totalReal += real;
    totalEstimate += estimate;
  });

  out.total = {
    real: totalReal,
    estimate: totalEstimate,
    diff: totalReal - totalEstimate,
  };
  return out;
};

export const buildMonthlyChartRows = (serie) => {
  if (!serie) return [];
  let acumReal = 0;
  let acumPpto = 0;
  return MESES.map((mes, i) => {
    const row = serie[mes] || { real: 0, estimate: 0, diff: 0 };
    acumReal += row.real || 0;
    acumPpto += row.estimate || 0;
    return {
      mes: `M${i + 1}`,
      real: row.real || 0,
      ppto: row.estimate || 0,
      diff: row.diff || 0,
      acumReal,
      acumPpto,
    };
  });
};

export const buildAnnualCompareRows = (epigrafes) =>
  (epigrafes || []).map((ep) => ({
    nombre: ep.label,
    id: ep.id,
    real: ep.serie?.total?.real ?? 0,
    ppto: ep.serie?.total?.estimate ?? 0,
    diff: ep.serie?.total?.diff ?? 0,
  }));
